// @flow
import React, {type Node} from 'react'
import css from './index.css'
import {resolveCss} from '$util'

type Props = {
  input: {
    value: mixed,
    onChange: Function
  },
  meta: {
    active: boolean,
    invalid: boolean
  },
  css?: any,
  label?: Node,
  disabled?: boolean,
  placeholder?: ?string,
  addonAfter?: Node,
  inputRef?: Function,
  style?: 'box',
  type?: 'number',
  'data-tid'?: string,
}

const TextInput = (props: Props) => {
  const classes = resolveCss(css, props.css)
  const {active, invalid} = props.meta
  return (
    <div {...classes('container', props.style, active && 'inFocus')}>
      {props.label && (
        <div {...classes('topRow')}>
          <label {...classes('label')}>{props.label}</label>
        </div>
      )}
      <div {...classes('inputWrapper')}>
        <input
          {...props.input}
          {...classes('input')}
          ref={props.inputRef}
          disabled={props.disabled}
          placeholder={props.placeholder}
          type={props.type || 'text'}
          data-tid={props['data-tid']}
        />
        {props.addonAfter && (
          <div {...classes('addonAfter', invalid && 'invalid')}>
            {props.addonAfter}
          </div>
        )}
      </div>
    </div>
  )
}

export default TextInput



// WEBPACK FOOTER //
// ./src/common/components/TextInput/index.js